/**
 * ============================================================================
 * useCreatePolicyMutation — Phase 6a frontend (T-P6a-W3-01)
 * Owner: Claude 3 (Frontend & UX).
 * Purpose: POST /api/v1/retention/policies — create a PENDING retention
 *          policy. Activation is a separate step (see useActivatePolicyMutation)
 *          and requires GMP-Critical dual signature.
 * ============================================================================
 */

import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { apiFetch, newIdempotencyKey } from '../../api/client';
import type {
  DataClass,
  RetentionAnchor,
  RetentionFormula,
  RetentionPolicy,
} from './usePoliciesQuery';

export interface CreatePolicyInput {
  name: string;
  doc_type_code: string;
  formula: RetentionFormula;
  formula_years: number | null;
  data_class: DataClass;
  anchors: RetentionAnchor[];
}

export function useCreatePolicyMutation(): UseMutationResult<
  RetentionPolicy,
  Error,
  CreatePolicyInput
> {
  return useMutation<RetentionPolicy, Error, CreatePolicyInput>({
    mutationFn: (input) =>
      apiFetch<RetentionPolicy>('/api/v1/retention/policies', {
        method: 'POST',
        body: input,
        idempotencyKey: newIdempotencyKey(),
      }),
  });
}
